import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import { SalesPlanModel, ISalesPlanModel } from '@common/models/SalesPlanModel';
import { ClinicSalesPlans } from '@common/models/ClinicSalesPlans';

export class SalesPlanService {
    private static baseUrl: string = '/api/salesPlan';
    static tags = {
        getAllSalesPlans: "getAllSalesPlans",
        getSalesPlan: "getSalesPlan",
        upsertSalesPlan: "upsertSalesPlan",
        deleteSalesPlan: "deleteSalesPlan"
    };

    static getAllSalesPlans = (): Promise<SalesPlanModel[]> => {
        return trackPromise(new Promise<SalesPlanModel[]>((resolve, reject) => {
            http(`${this.baseUrl}`)
                .getVersioned<ClinicSalesPlans>("sales-plans")
                .then(resp => resp.salesPlans.map(r => new SalesPlanModel(r)))
                .then(resolve)
                .catch(reject)
        }), this.tags.getAllSalesPlans);
    };

    static getSalesPlan = (salesPlanId: number): Promise<SalesPlanModel> => {
        return trackPromise(new Promise<SalesPlanModel>((resolve, reject) => {
            http(`${this.baseUrl}/${salesPlanId}`).get<ISalesPlanModel>()
                .then((response) => new SalesPlanModel(response))
                .then(resolve)
                .catch((err) => {
                    reject(err);
                })
        }), this.tags.getSalesPlan);
    };

    static upsertSalesPlan = (data: ISalesPlanModel): Promise<SalesPlanModel> => {
        return trackPromise(new Promise<SalesPlanModel>((resolve, reject) => {
            http(`${this.baseUrl}/update/`).post<ISalesPlanModel>(data)
                .then((response) => new SalesPlanModel(response))
                .then(resolve)
                .catch((err) => {
                    reject(err);
                })
        }), this.tags.upsertSalesPlan);
    };

    static deleteSalesPlans = (salesPlanId: number): Promise<boolean> => {
        return trackPromise(new Promise<boolean>((resolve, reject) => {
            http(`${this.baseUrl}/delete/${salesPlanId}`).delete()
                .then(() => {
                    resolve(true);
                })
                .catch((err) => {
                    reject(err);
                })
        }), this.tags.deleteSalesPlan);
    };
}
